import { FC, useEffect, useRef, useState } from 'react';
import TextSliderContent from './TextSliderContent';
import Text, { ThemeKey } from './Text';

const text: { name: string; theme: ThemeKey }[] = [
  { name: 'First Nations', theme: 'GREEN' },
  { name: 'Metis Nations', theme: 'BLUE' },
  { name: 'Tribal Councils', theme: 'ORANGE' },
  { name: "NGO's", theme: 'PURPLE' },
];

const TextSlider: FC = () => {
  const autoPlayRef = useRef<() => void>();

  useEffect(() => {
    autoPlayRef.current = nextSlide;
  });

  useEffect(() => {
    const play = () => {
      autoPlayRef.current && autoPlayRef.current();
    };

    const interval = setInterval(play, 3000);
    return () => clearInterval(interval);
  }, []);

  const [state, setState] = useState({
    activeIndex: 0,
    translate: 0,
    transition: 1100,
  });

  const { translate, transition, activeIndex } = state;

  const nextSlide = () => {
    if (activeIndex === text.length - 1) {
      return setState({
        ...state,
        translate: 0,
        activeIndex: 0,
      });
    }

    setState({
      ...state,
      activeIndex: activeIndex + 1,
      translate: (activeIndex + 1) * 32,
    });
  };

  return (
    <div className='relative overflow-hidden w-80 xl:w-128 h-full'>
      <TextSliderContent translate={translate} transition={transition}>
        {text.map((t, i) => (
          <Text key={i} text={t} />
        ))}
      </TextSliderContent>
    </div>
  );
};

export default TextSlider;
